import { throwError as observableThrowError, from as fromPromise } from 'rxjs';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';

import * as UserActions from '@app/core/user/store/actions/user.actions';
import * as FeedActions from '@app/+feed/store/actions/feed.action';
import * as localForage from 'localforage';
import { UsersService, ProductsService, CommentsService, UserLikes } from '@vestiaire/api-sdk-angular';
import { LikeTypes } from '@app/shared/components/like/like-types.enum';

@Injectable()
export class LikeService {
  likedItem: UserLikes = {
    products: [],
    comments: [],
    brands: []
  };
  constructor(
    private store: Store<IAppState>,
    private productsService: ProductsService,
    private commentsService: CommentsService,
    private usersService: UsersService
  ) {}

  setLikedItem() {
    fromPromise(localForage.getItem('likedItem')).subscribe(
      res => {
        if (!res) {
          this.usersService.getLikes().subscribe(
            likedItem => {
              const newItemLiked = likedItem.data;
              localForage.setItem('likedItem', newItemLiked);
              this.store.dispatch({
                type: UserActions.SET_USER_LIKED_ITEMS,
                payload: newItemLiked
              });
            },
            error => {
              console.log(error);
            }
          );
        } else {
          this.store.dispatch({
            type: UserActions.SET_USER_LIKED_ITEMS,
            payload: res
          });
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  like(type: string, id: string) {
    this.addLikeToLocalForage(id, type);

    switch (type) {
      case LikeTypes.COMMENTS:
        return this.commentsService.likeComment(id);
      case LikeTypes.PRODUCTS:
        return this.productsService.likeProduct(id);
      default:
        return observableThrowError({
          error: `type : ${type} not found in like service`
        });
    }
  }

  unLike(type: string, id: string) {
    this.removeLikeToLocalForage(id, type);

    switch (type) {
      case LikeTypes.COMMENTS:
        return this.commentsService.unlikeComment(id);
      case LikeTypes.PRODUCTS:
        return this.productsService.unlikeProduct(id);
      default:
        return observableThrowError({
          error: `type : ${type} not found in unlike service`
        });
    }
  }

  /*
  LIKE BRAND TODO
  Likebrand(id) {
    this.addLikeToLocalForage(id, 'products');
    return this.productsService.likeProduct(id);
  }

  unLikebrand(id) {
    return this.productsService.unlikeProduct(id);
  }
  */

  addLikeToLocalForage(idItem, type) {
    fromPromise(localForage.getItem('likedItem')).subscribe(
      res => {
        const newLikedItems = res;
        if (newLikedItems[type] && newLikedItems[type].indexOf(idItem) === -1) {
          newLikedItems[type].push(String(idItem));
        }

        localForage.setItem('likedItem', newLikedItems);

        this.store.dispatch({
          type: UserActions.SET_USER_LIKED_ITEMS,
          payload: newLikedItems
        });
        this.store.dispatch({
          type: FeedActions.SET_PRODUCT_LIKE,
          payload: idItem
        });
      },
      error => {
        console.log(error);
      }
    );
  }

  removeLikeToLocalForage(idItem, type) {
    fromPromise(localForage.getItem('likedItem')).subscribe(
      res => {
        const newLikedItems = res;
        if (newLikedItems[type]) {
          newLikedItems[type] = newLikedItems[type].filter(item => {
            if (item !== String(idItem)) {
              return item;
            }
          });
        }

        localForage.setItem('likedItem', newLikedItems);

        this.store.dispatch({
          type: UserActions.SET_USER_LIKED_ITEMS,
          payload: newLikedItems
        });
        this.store.dispatch({
          type: FeedActions.SET_PRODUCT_UNLIKE,
          payload: idItem
        });
      },
      error => {
        console.log(error);
      }
    );
  }
}
